<template>
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <button
          class="btn btn-outline-success"
          style="border-radius: 50%"
          @click="back"
        >
          <i class="fas fa-arrow-left" />
        </button>
      </div>
      <div
        v-if="category"
        class="text-right category-name"
      >
        {{ category.name }}
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-8 pb-4">
        <h1 class="mt-4">
          {{ badge.spec.name }}
        </h1>
        <div
          v-if="badge.spec.keywords && badge.spec.keywords.length > 0"
          class="text-success"
        >
          #{{ badge.spec.keywords.join(' #') }}
        </div>

        <div class="font-italic pt-2 font-weight-light">
          {{ badge.spec.comment }}
        </div>
      </div>
      <div class="col-12 col-md-4 py-4">
        <BadgeTree :badges="icons" />
      </div>
    </div>

    <div
      v-for="b in icons"
      :key="b.bid"
      class="row pb-3"
    >
      <div
        style="width: 150px; flex-shrink: 0"
        class="p-3 col-12 col-md-auto text-center"
      >
        <img
          :src="b.icon"
          class="w-100"
          style="max-width: 150px;"
        >
      </div>
      <div class="col-12 col-md flex-grow-1 pt-1">
        <div
          class="d-flex align-items-center"
          style="line-height: 1"
        >
          <div class="text-success stars">
            <span
              v-for="s in b.stars"
              :key="s"
              class="font-weight-bold"
              style="font-size: 30px"
            >*</span>
          </div>
          <div
            class="pl-3 font-weight-bold pb-2"
            style="font-size: 22px"
          >
            {{ b.name }}
          </div>
        </div>
        <ul>
          <li
            v-for="(req, i) in b.requirements"
            :key="i"
          >
            {{ req }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BadgeTree from '../components/BadgeTree';

export default {
  props: {
    pending: Boolean,
    badgeId: String,
  },
  components: {
    BadgeTree,
  },
  computed: {
    ...mapState({
      badges: (state) => state.badges,
      categories: (state) => state.categories,
    }),
    icons() {
      if (!this.badge) return [];
      const icons = this.badge.spec.badgeIcons || {};

      return this.badge.spec.badges
        .map((b) => ({
          ...b,
          icon: icons[b.id]
            ? `${process.env.VUE_APP_AUTH_API}/img/form/${icons[b.id]}` : null,
        }))
        .sort((a, b) => a.stars - b.stars);
    },
    category() {
      if (!this.badge) return null;
      return this.categories.find((x) => x.id === this.badge.category);
    },
    badge() {
      return this.badges.find((x) => x.bid === this.badgeId);
    },
  },
  methods: {
    back() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
  h1 {
    text-transform: uppercase;
    font-weight: 800;
  }

  .category-name {
    text-transform: uppercase;
    font-weight: 600;
    color: #7e7e7e;
  }
</style>
